import { useEffect, useState } from "react";
var listeners = new Set();
/**
 * @param initialState {T} hook initial state
 * @param actions {StoreActions<T, A>} actions that will modify the state
 */
function makeGlobal(initialState, actions) {
    var globalState = initialState;
    var setStateGlobal = function (newState) {
        globalState = newState;
        listeners.forEach(function (l) { return l(); });
    };
    var newActions = {};
    Object.keys(actions).forEach(function (key) {
        newActions[key] = function () {
            var params = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                params[_i] = arguments[_i];
            }
            return actions[key]({
                setState: setStateGlobal,
                state: globalState,
            }).apply(void 0, params);
        };
    });
    return function () {
        var _a = useState(globalState), state = _a[0], setState = _a[1];
        useEffect(function () {
            var listener = function () {
                setState(globalState);
            };
            listeners.add(listener);
            listener(); // in case it's already changed
            return function () {
                listeners.delete(listener); // cleanup
            };
        }, []);
        return [state, newActions];
    };
}
export default makeGlobal;
//# sourceMappingURL=makeGlobal.js.map